export default __webpack_public_path__ + "cdd9a6573b2ac924a271a297d68d8cf7.png";